import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import toNumber from 'lodash/toNumber';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import { DP_USER_STATE, DP_REWARDS_CERTS } from '../../common/Constants';

export default class Routing {
    /*
     *  This function will only return true only when user_state is 1
     * Otherwise redirect to signin to step-up with nextUrl
     *  It won't return a value of 'DP_USER_STATE'
     *  USAGE : RouteEnter.ensureRestrictedRoute('/next/url',true)
     */
    static ensureRestrictedRoute(nextUrl = '', softRedirect = false, skipRedirection = false) {
        const userState = TokenProvider.get(DP_USER_STATE) || '0';

        if (userState === '1') {
            return true;
        }

        /* istanbul ignore next */
        if (skipRedirection) {
            return false;
        }

        return this.stepupTo(nextUrl, softRedirect);
    }

    /*
     *  This function will only return true only when user is logged (user_state is 1 or 2)
     * Otherwise redirect to signin to step-up with nextUrl
     *  It won't return a value of 'DP_USER_STATE'
     *  USAGE : RouteEnter.ensureAuthenticatedRoute()
     */
    static ensureAuthenticatedRoute(nextUrl = '', softRedirect = false, skipRedirection = false) {
        const userState = TokenProvider.get(DP_USER_STATE) || '0';

        if (userState !== '0') {
            return true;
        }

        /* istanbul ignore next */
        if (skipRedirection) {
            return false;
        }

        return this.stepupTo(nextUrl, softRedirect);
    }

    /*
     *  This function will only return true only when user is logged
     * (user_state is 1 or 2 only if no certificate in rewards profile)
     * Otherwise redirect to signin to step-up with nextUrl
     *  It won't return a value of 'DP_USER_STATE'
     *  USAGE : RouteEnter.ensureAuthenticatedRoute()
     */
    static ensureRewardsRecognizedState(
        nextUrl = '',
        softRedirect = false,
        skipRedirection = false
    ) {
        const userState = TokenProvider.get(DP_USER_STATE) || '0';
        const rewardsCerts = toNumber(TokenProvider.get(DP_REWARDS_CERTS)) || 0;
        const rewardsCertsCount = toNumber(TokenProvider.get('DP_REWARDS_CERTS_COUNT')) || 0;

        if (userState === '1' || (userState === '2' && !rewardsCerts && !rewardsCertsCount)) {
            return true;
        }

        /* istanbul ignore next */
        if (skipRedirection) {
            return false;
        }

        return this.stepupTo(nextUrl, softRedirect);
    }

    /*
     *  This function will redirect to signin to step-up with nextUrl
     *  This function assume you are intelligent enough to know why are you doing it
     *  USAGE : RouteEnter.stepupTo(nextUrl,)
     */
    static stepupTo(nextUrl = '', softRedirect = false) {
        if (__SERVER__) return undefined;

        const nextRedirectUrl = nextUrl || `${window.location.pathname}${window.location.search}`;
        return this.redirect(`/signin?next=${nextRedirectUrl}`, softRedirect) || false;
    }

    /*
     *  This function will redirect to url passed based on soft redirect or
     *  This function assume you are intelligent enough to know why are you doing it
     *  USAGE : RouteEnter.redirect('/any/url',true)
     */
    static redirect(url = '', softRedirect = false) {
        if (__SERVER__) return undefined;

        if (softRedirect) {
            return getBrowserHistory().push(url) || false;
        }
        return window.location.assign(url) || false;
    }
}
